export default __webpack_public_path__ + "static/media/SWT0990.34I-27953_-16766_0.22c5f15e.jpg";